import TiledSelect from './tiled-select.vue';
import TiledSelectGroup from './tiled-select-group.vue';
TiledSelect.group = TiledSelectGroup;
export default TiledSelect;


// WEBPACK FOOTER //
// ./src/components/tiled-select/index.js